export default "__VITE_ASSET__B0tgyq17__"